import React from 'react'
import { Box, Checkbox, IconButton, Tooltip, Typography, Switch, Divider } from "@mui/material";

const AllotmentItem = (props) => {

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'start',
                width: `${props.width ? props.width : '20%'}`,
                flexBasis: `${props.width ? props.width : '20%'}`,
                flexGrow: 1,
            }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography
                    variant="h4"
                    flexGrow={1}
                    fontSize={12}
                    textAlign={'center'}
                    fontWeight={500}
                    color="primary">
                    Allotment
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}>

                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    textAlign={'center'}
                                    fontWeight={500}
                                    color="primary">
                                    Used
                                </Typography>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    textAlign={'center'}
                                    fontSize={14}
                                    fontWeight={400}>
                                    {props.used}
                                </Typography>
                            </Box>
                            <Divider
                                orientation="vertical"
                                flexItem
                                sx={{ borderRightWidth: 2, pl: 1, mr: 1 }}
                            />
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    fontSize={12}
                                    textAlign={'center'}
                                    fontWeight={500}
                                    color="primary">
                                    Alloted
                                </Typography>
                                <Typography
                                    variant="h4"
                                    flexGrow={1}
                                    textAlign={'center'}
                                    fontSize={14}
                                    fontWeight={400}>
                                    {props.alloted}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default AllotmentItem;